module.exports = __webpack_public_path__ + "assets/img/picture2.f46c8551.png";